import React from 'react'
import { ActivityFeed, useLocationContext } from '@therms/react-modules'

export function LocationActivityFeed() {
  // if not in a location context, then all locations will be shown
  const locationCtx = useLocationContext()

  return (
    <div className="w-full">
      <ActivityFeed locationId={locationCtx?.locationId} />
    </div>
  )
}
